import React, { useMemo } from "react";

/**
 * MobileBoardPagination
 * - 모바일 전용 페이지네이션 컴포넌트
 * - UI 모바일 대응
 * - 이전, 페이지 정보, 다음 버튼이 1행에 나란히 표시
 */
export default function MobileBoardPagination({
  page = 1,
  pageSize = 15,
  total = 0,
  onPageChange,
  className = "",
}) {
  const totalPages = useMemo(() => {
    const t = Math.max(0, Number(total) || 0);
    const p = Math.max(1, Number(pageSize) || 1);
    const pages = Math.ceil(t / p);
    return Math.max(1, pages);
  }, [total, pageSize]);

  const canPrev = page > 1;
  const canNext = page < totalPages;

  return (
    <div
      className={[
        "flex items-center justify-center gap-1 text-xs min-w-0",
        className,
      ].join(" ")}
    >
      <button
        className="rounded-lg border border-gray-300 px-2 py-1 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed text-xs font-medium whitespace-nowrap flex-shrink-0"
        disabled={!canPrev}
        onClick={() => onPageChange && onPageChange(page - 1)}
      >
        이전
      </button>
      <span className="text-gray-600 text-xs whitespace-nowrap flex-shrink-0 px-2">
        {page} / {totalPages} {total ? `(${total}건)` : ""}
      </span>
      <button
        className="rounded-lg border border-gray-300 px-2 py-1 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed text-xs font-medium whitespace-nowrap flex-shrink-0"
        disabled={!canNext}
        onClick={() => onPageChange && onPageChange(page + 1)}
      >
        다음
      </button>
    </div>
  );
}

